var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-dropdown",
        {
          staticClass: "m-2",
          attrs: { split: "", text: "Novo", variant: "primary" },
          on: { click: _vm.addNew },
          scopedSlots: _vm._u([
            {
              key: "button-content",
              fn: function() {
                return [
                  _c("feather-icon", {
                    staticClass: "mr-50",
                    attrs: { icon: "PlusIcon" }
                  }),
                  _c("span", { staticClass: "align-middle" }, [
                    _vm._v(_vm._s(_vm.$t("AddNew")))
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "b-dropdown-item",
            {
              on: {
                click: function($event) {
                  _vm.showImportModal = !_vm.showImportModal
                }
              }
            },
            [_vm._v("Importar")]
          )
        ],
        1
      ),
      _c("Grid", {
        attrs: {
          css_formats: _vm.gridCssFormats(),
          service: _vm.service,
          route_name: "legal_entities"
        },
        scopedSlots: _vm._u([
          {
            key: "gridThead",
            fn: function(thead) {
              return _vm._l(thead.data, function(column, key) {
                return _c(
                  "vs-th",
                  {
                    key: key,
                    attrs: {
                      "sort-key": thead.methods.getColumnSortKey(key),
                      "sort-status": "asc"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t(thead.methods.getColumnName(column))))]
                )
              })
            }
          },
          {
            key: "gridData",
            fn: function(gridData) {
              return _vm._l(gridData.data, function(tr, indextr) {
                return _c(
                  "vs-tr",
                  { key: indextr, attrs: { data: tr } },
                  [
                    _vm._l(gridData.columns, function(column, key) {
                      return _c(
                        "vs-td",
                        {
                          key: key,
                          attrs: { data: gridData.data[indextr].id }
                        },
                        [
                          _c(
                            "div",
                            {
                              class: gridData.methods.getColumnCss(
                                gridData.data[indextr],
                                key
                              )
                            },
                            [
                              _c("div", {
                                directives: [
                                  {
                                    name: "html-safe",
                                    rawName: "v-html-safe",
                                    value:
                                      "<div>" +
                                      gridData.methods.getColumnData(
                                        gridData.data[indextr],
                                        key
                                      ) +
                                      "</div>",
                                    expression:
                                      "\n                `<div>${gridData.methods.getColumnData(\n                  gridData.data[indextr],\n                  key\n                )}</div>`\n              "
                                  }
                                ],
                                key: key
                              })
                            ]
                          )
                        ]
                      )
                    }),
                    _c("vs-td", [
                      _c(
                        "div",
                        { staticClass: "flex flex-row gap-1" },
                        [
                          _vm.isHeadquarters(gridData.data[indextr])
                            ? _c("feather-icon", {
                                staticClass:
                                  "hover:text-primary rounded text-dark h-5 w-5 stroke-current",
                                attrs: { icon: "HomeIcon" },
                                on: {
                                  click: function($event) {
                                    return _vm.openLegalUnits(
                                      gridData.data[indextr]
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          !_vm.hide_edit
                            ? _c("feather-icon", {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "legal_entities.edit",
                                    expression: "`legal_entities.edit`"
                                  }
                                ],
                                staticClass:
                                  "h-5 w-5 stroke-current text-warning",
                                attrs: { icon: "EditIcon" },
                                on: {
                                  click: function($event) {
                                    return gridData.edit(
                                      gridData.data[indextr].id
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          !_vm.hide_delete
                            ? _c("feather-icon", {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "legal_entities.delete",
                                    expression: "`legal_entities.delete`"
                                  }
                                ],
                                staticClass:
                                  "h-5 w-5 stroke-current text-danger",
                                attrs: { icon: "Trash2Icon" },
                                on: {
                                  click: function($event) {
                                    return _vm.confirmDestroy(
                                      gridData.data[indextr],
                                      gridData.fetchGridData
                                    )
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ],
                  2
                )
              })
            }
          }
        ])
      }),
      _c("legal-units-popup", { ref: "units_popup" }),
      _c(
        "vs-popup",
        {
          attrs: {
            title: "Importar Pessoa Jurídica",
            active: _vm.showImportModal
          },
          on: {
            "update:active": function($event) {
              _vm.showImportModal = $event
            }
          }
        },
        [
          _c("ImportExcel", {
            attrs: {
              onSuccess: _vm.onSuccess,
              templateMessage:
                "Clique aqui para baixar um modelo para <br/> o preenchimento de importação de pessoa jurídica.",
              accept: ".xlsx, .xls"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }